"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCanvasFromImage = createCanvasFromImage;
exports.initTextureCanvas = initTextureCanvas;
var _createCanvas = require("./createCanvas");
var _optimizeTextureImage = require("./optimizeTextureImage");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function createCanvasFromImage(image) {
  var _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(image, true),
    _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 1),
    canvas = _createWorkingCanvas2[0];
  return canvas;
}
function initTextureCanvas(texture) {
  if (!texture.image) {
    // eslint-disable-next-line no-console
    console.warn("There is no image for the given texture.", texture);
  }
  if (!texture.originalImage || texture.image.nodeName !== "CANVAS") {
    var _texture$image, _texture$userData;
    var originalImage = (0, _optimizeTextureImage.optimizeTextureImage)(texture.image);
    // eslint-disable-next-line no-console
    texture.userData.src = ((_texture$image = texture.image) === null || _texture$image === void 0 ? void 0 : _texture$image.src) || ((_texture$userData = texture.userData) === null || _texture$userData === void 0 ? void 0 : _texture$userData.src);
    console.log("Creating canvas from texture: ".concat(texture.userData.src));
    texture.image = createCanvasFromImage(originalImage);
    texture.originalImage = originalImage;
  } else {
    // eslint-disable-next-line no-console
    console.log("Texture for ".concat(texture.originalImage.src, " is already prepared, skipping."));
  }
}